import uniqid from 'uniqid';
import PropTypes from 'prop-types';

import FlightDetailsHead from '../flightDetailsHead/FlightDetailsHead';

import './FlightClassDetails.scss';

const FlightClassDetails = ({ cabinClass = null, labels, flights }) => {
  return (
    <div className="iw-flight-list-flight-class-details">
      {flights.map((flight) => (
        <div
          className="iw-flight-list-flight-class-details__flex"
          key={flight.departureDateTime}
        >
          <FlightDetailsHead
            flight={flight}
            labels={labels}
            hideFlightTime
            withCarrierInfo
            carrierAdditionalText={cabinClass}
          />
          {flight.legs.map((leg) => {
            return (
              <div key={uniqid('cabin-class-leg-')}>
                <p className="iw-flight-list-flight-class__departure-location">
                  {`${labels.from} ${leg.departureLocation}`}
                </p>
                <ul className="iw-flight-list-flight-class-details__text">
                  {flight.cabinClassTexts.map((cabinClassText) => (
                    <li
                      key={uniqid('cabin-class-')}
                      className="iw-flight-list-flight-class-details__li"
                    >
                      {cabinClassText}
                    </li>
                  ))}
                </ul>
              </div>
            );
          })}
        </div>
      ))}
    </div>
  );
};

FlightClassDetails.propTypes = {
  cabinClass: PropTypes.string,
  flights: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  labels: PropTypes.shape({
    from: PropTypes.string,
  }).isRequired,
};

export default FlightClassDetails;
